import { ODDS_ENDS_DEALS_ICON_URL } from 'honeydew/icons/PlusMembership';
import { getResizedCDNAsset } from 'utils/globalUtils';

import BenefitBase from './shared/BenefitBase';

/**
 * OddsEndsBenefit component that displays Odds & Ends membership benefit
 * @param {Object} props - Component props
 * @param {string} [props.bgColor='bg-white'] - Background color class for the benefit
 * @param {'horizontal' | 'responsive'} [props.layout='responsive'] - Layout orientation for the benefit
 * @returns {JSX.Element} Rendered Odds & Ends benefit
 */
function OddsEndsBenefit({ bgColor = 'bg-white', layout = 'responsive' }) {
    const horizontalImage = (
        <img
            src={getResizedCDNAsset({ url: ODDS_ENDS_DEALS_ICON_URL, width: 150 })}
            alt="odds and ends deals"
            width={150}
        />
    );

    const verticalImage = (
        <img
            src={getResizedCDNAsset({ url: ODDS_ENDS_DEALS_ICON_URL, width: 120 })}
            alt="odds and ends deals"
            width={120}
        />
    );

    return (
        <BenefitBase
            bgColor={bgColor}
            headline="Odds & Ends deals"
            subheadline="Even steeper discounts on items from our own brand"
            verticalImage={verticalImage}
            horizontalImage={horizontalImage}
            horizontalImagePosition="bottom-[-20px] left-0 right-[10px] top-[-20px]"
            layout={layout}
        />
    );
}

export default OddsEndsBenefit;
